<template>
    <div class="notice-popup-container">
        <div v-for="(notice, index) in rt_notices" :key="notice.id" class="notice-popup" :style="popupStyle(index)">
            <div id="rt_popup_header">
                <span class="popup-title">{{ notice.title }}</span>
            </div>
            <div class="popup-body">
                {{ notice.message }}
            </div>
            <div id="rt_popup_footer">
                <button class="notice_close_button" @click="closeAndHideToday(notice.id)">
                    닫기
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['rt_notices'],
    methods: {
        popupStyle(index) {
            const baseDistance = 100; // 초기 거리
            const distanceMultiplier = 35; // 거리 배수

            return {
                top: `${baseDistance + index * distanceMultiplier}px`,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1000 + index,
            };
        },
        closeAndHideToday(noticeId) {
            this.$emit('remove', noticeId);
        },
        closeAllPopups() {
            // 모든 팝업 닫기
            this.notices.forEach((notice, index) => {
                this.closeAndHideToday(notice.id, index);
            });
        }
    }
};
</script>

<style>
#rt_popup_footer {
    flex: 2;
    margin-top: 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* 내용과 버튼을 양쪽 끝에 배치 */
    border-top: 1px solid #ccc;
    /* 상단 구분선 추가 */
}
#rt_popup_header {
    padding: 10px 5px 5px 5px;
    flex: 3;
    font-size: 1.1em;
    font-weight: bold;
    height: 50px;
    background-color: #ff4444;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: 1px solid #ccc;
}
</style>